"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const sliceReview_1 = require("../../../../reviews-modal/slice/sliceReview");
const constants_1 = require("../../../../reviews-modal/slice/sliceReview/constants");
const helper_1 = require("../../../helper");
const ReviewModalContext_1 = require("../../ReviewModalContext");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const REQUEST = window.pulse.request;
const JOB_ID = REQUEST.jobId;
const JOB_TITLE = REQUEST.jobTitle;
const EMPTY_MESSAGES = {
    reviews: "Click 'Create Review' below to get started.",
    project: "Click 'Create Review' above to get started.",
    task: "No reviews linked to this task. Click 'Create Review' or 'Link Reviews' above to get started.",
    widget: 'No reviews available in this view. Use the filter to change the view.',
};
const EmptyTitle = ({ scope }) => {
    const { setOpenReviewModal, gridAction } = (0, react_1.useContext)(ReviewModalContext_1.CreateReviewModalContext);
    const dispatch = (0, react_redux_1.useDispatch)();
    const isFiltered = gridAction === helper_1.GRID_ACTIONS.FILTER;
    const content = isFiltered && scope !== 'task'
        ? 'No reviews match the applied filters or search. Change them to see more reviews.'
        : EMPTY_MESSAGES[scope];
    const isDisplayButton = scope === 'reviews' && !isFiltered;
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['empty-review__root'] },
        react_1.default.createElement("p", { className: styles_modules_less_1.default['empty-review__content'] }, content),
        isDisplayButton && (react_1.default.createElement(pulse_components_1.PulseButton, { label: "Create review", icon: true, iconClasses: {
                icon: 'fal fa-plus',
            }, classes: [styles_modules_less_1.default['empty-review__createBtn']], color: pulse_components_1.Colors.success, onClick: () => {
                if (setOpenReviewModal) {
                    setOpenReviewModal(true);
                }
                dispatch((0, sliceReview_1.openModal)({
                    status: constants_1.MODE.create,
                    id: JOB_ID,
                    label: JOB_TITLE,
                }));
            } }))));
};
const EmptyReview = ({ scope }) => {
    const isPageReview = scope === 'reviews';
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('empty-review', styles_modules_less_1.default['empty-review-container']) },
        react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default['empty-review'], isPageReview && styles_modules_less_1.default['empty-review--reviewPage']) },
            react_1.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default['empty-review__icon'], 'fa-regular fa-file-magnifying-glass') }),
            react_1.default.createElement(EmptyTitle, { scope: scope }))));
};
exports.default = EmptyReview;
